import { HubModuleType, ICreateMyEventsHubModuleDTO, IMyEventsHubModuleDTO, TCreateHubModuleDTO, } from '../../../../../../../../api/event-hubs.dao';
import { MY_EVENTS_MODULE_CONFIG } from './my-events-module.config';
import { EventsBaseModuleVM } from '../_events-base/events-base-module.viewmodel';

export class MyEventsModuleVM extends EventsBaseModuleVM {
    public static createEmpty(positionOrder: number): MyEventsModuleVM {
        return new MyEventsModuleVM({ positionOrder: positionOrder });
    }

    public static createFromDTO(dto: IMyEventsHubModuleDTO | ICreateMyEventsHubModuleDTO): MyEventsModuleVM {
        const initialData = MyEventsModuleVM.fromEventsBaseModuleDTO(dto);
        return new MyEventsModuleVM(initialData);
    }

    private constructor(module: Partial<IMyEventsHubModuleDTO>) {
        super(module.moduleId, 'MyEventsModuleVM', MY_EVENTS_MODULE_CONFIG, module);
        this.savedSnapshot = this.serialize();
    }

    public getModuleType = (): HubModuleType => {
        return HubModuleType.MY_EVENTS;
    };

    public toCreateDTO = (): ICreateMyEventsHubModuleDTO => {
        const eventsBaseModuleDTO = this.toEventsBaseModuleDTO();

        return {
            ...eventsBaseModuleDTO,
            moduleType: HubModuleType.MY_EVENTS,
        };
    };

    protected cloneFromDTO = (dto: TCreateHubModuleDTO): MyEventsModuleVM => {
        const myEventsModuleDTO = dto as ICreateMyEventsHubModuleDTO;
        return MyEventsModuleVM.createFromDTO(myEventsModuleDTO);
    };
}
